<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<div class="menu-bg shadow">
  <!--<div class="d-flex justify-content-end align-items-end pe-3 pt-3">
    <img class="hamburger" src="./assets/icons/hamburger.svg" width="24" height="24" />
  </div>-->
  <div class="text-center pt-5 pb-4">
    <img src="./assets/images/images/main-user.png" width="56" height="56" />
    <h4 class="pt-4 m-0 fw-bold">{{NameView}}</h4>
    <p class="m-0">{{IDNoView}}</p>
    <div class="dropdown d-flex flex-column mx-2 mt-3">
      <select class="form-select border-0 shadow" [(ngModel)]="FirmInput" [ngModelOptions]="{standalone: true}" (change)="ChangeFirm(FirmInput)">
        <option *ngFor="let res of StaffFirmDetails" [value]="res.firmID">{{res.firmName}}</option>
      </select>
      <!--<button class="btn btn-white dropdown-toggle shadow" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
      Jenis Firma
    </button>
    <ul class="dropdown-menu w-100" aria-labelledby="dropdownMenuButton1">
      <li class="dropdown-item">Digital. net</li>
      <li><hr class="dropdown-divider mx-3" /></li>
      <li class="dropdown-item">Technology. net</li>
      <li><hr class="dropdown-divider mx-3" /></li>
      <li class="dropdown-item">System. net</li>
    </ul>-->
    </div>
    <p class="text-center pt-4 fs-6">TIN Firma : {{FirmTaxRefNum}}</p>
    <p class="mt-4 text-center" style="font-size: 14px">Log masuk terakhir anda:</p>
    <p class="fw-bold fst-italic text-center">{{LastLoginView}}</p>
    <!--<span class="fw-bold fst-italic">{{LastLoginView}}</span>-->
  </div>
</div>
